<template>
  <div>
    <div
      v-show="products.length"
      ref="carousel"
      class="carousel slide px-4"
      data-ride="carousel"
      data-interval="false"
    >
      <ol
        v-if="totalSlides > 1"
        class="indicators"
      >
        <li
          v-for="index in totalSlides"
          :key="index"
          :class="{'active': currentSlide === (index-1)}"
          @click="goto(index - 1)"
        >
          <font-awesome-icon
            icon="circle"
            style="font-size: 4px"
          />
        </li>
      </ol>
      <div class="carousel-inner">
        <div
          v-for="slideindex in totalSlides"
          :key="`slide_${slideindex}`"
          :class="`carousel-item ${slideindex === 1 ? 'active' : ''} w-100`"
        >
          <div class="d-flex justify-content-start">
            <!--
            similar: src/components/Widgets/Activity/ActivityItems.vue:8
            e.g. <activity-container> => <views-list> => <activity-cell> => <activity-items>
            -->
            <div
              v-for="(product, pindex) in productsInSlide(slideindex)"
              :key="`product_${pindex}`"
              class="d-flex flex-column justify-content-between align-items-center"
              :style="`width: ${Math.floor(100/slideSize)}%`"
            >
              <product
                :key="`product_${product.url}_${pindex}`"
                :style="pindex > 0 ? `margin-left: ${marginBetween}px` : ''"
                :count="itemsCount(product)"
                :name="getProductName(product)"
                :pk="product.pk"
                :price="product.formatted_price"
                :size="product.size_info"
                :thumbnail="product.thumb_broken ? 'broken' : product.thumb || product.product_thumbnail "
                :thumbnail-size="responsive.lg? 'medium': 'small'"
                :url="product.site_url"
                :click-handler="onProductClicked"
                :date-verb="isLink(product) ? 'Last Viewed':dateVerb"
                :last-update="product.last_update || lastUpdated || product.max_timestamp * 1000"
                :no-tooltip="noTooltip"
                :show-size="showSize"
                :is-like="product.isActivityLike || product.is_like"
                :liked-location="formatLikeLocationLabel(product)"
                :placeholder = "product.placeholder"
              />
              <base-text
                v-if="product.footer"
                size="m"
              >
                {{ product.footer }}
              </base-text>
            </div>
          </div>
        </div>
      </div>
      <a
        v-if="currentSlide !== 0"
        class="carousel-control-prev"
        href="#"
        role="button"
        data-slide="prev"
        @click.prevent.stop="prev()"
      >
        <base-icon icon="left-arrow" />
        <span class="sr-only">Previous</span>
      </a>
      <a
        v-if="currentSlide !== (totalSlides-1)"
        class="carousel-control-next"
        href="#"
        role="button"
        data-slide="next"
        @click.prevent.stop="next()"
      >
        <base-icon icon="right-arrow" />
        <span class="sr-only">Next</span>
      </a>
    </div>
    <div v-show="products.length === 0">
      <empty title="No data yet" />
    </div>
  </div>
</template>
<script>
import $ from 'jquery';
import utilsMixin from '@/_utilities/utilsMixin';
import responsive from '@/components/mixins/responsive';
import product from './Widgets/Product';

export default {
  name: 'ProductsCarousel',
  components: {
    product,
  },
  mixins: [utilsMixin, responsive],
  props: {
    showSize: {
      type: Boolean,
      default: true,
    },
    products: {
      type: Array,
      default: () => [],
    },
    width: {
      required: true,
      type: Number,
    },
    lastUpdated: {
      type: String,
      default: '',
    },
    dateVerb: {
      type: String,
      default: 'Added',
    },
    perSlide: {
      type: Number,
      default: null,
    },
    noTooltip: {
      type: Boolean,
      default: false,
    },
    clickHandler: {
      type: Function,
      required: false,
    },
    /* If clicked, opens on new tab. Else, re-emits click event. */
    clickToNewTab: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      carousel: null,
      currentSlide: 0,
      marginBetween: 4,
    };
  },
  computed: {
    totalSlides() {
      const slideSize = this.slideSize <= 1 ? 1 : this.slideSize;
      const fittingSlides = Math.ceil(this.products.length / slideSize);
      return fittingSlides;
    },
    /* for testing */
    fakeproducts() {
      return [...Array(30).keys()].map((index) => this.products[index % this.products.length]);
    },
    slideWidth() {
      return this.width - 48; // Substract side paddings px-4
    },
    slideSize() {
      // TODO: 120 is hardcoded! Refers to thumbnail medium size.
      const itemsPerSlide = Math.floor((this.slideWidth - 120) / (120 + this.marginBetween)) + 1;
      return this.perSlide ? Math.min(this.perSlide, itemsPerSlide) : itemsPerSlide; // Consider margin between thumbnails
    },
  },
  watch: {
    width(newval) {
      console.log('width changed: ', newval);
      this.initCarousel();
    },
  },
  mounted() {
    this.$nextTick().then(() => {
      this.carousel = $(this.$refs.carousel);
      this.initCarousel();
    });
  },
  methods: {
    onProductClicked(params) {
      if (this.clickToNewTab) { return this.openInNewTab(params._props.url); }

      return this.$emit('click', params);
    },
    initCarousel() {
      if (!this.carousel) {
        console.log('carousel not available yet');
        return;
      }
      console.log('Initializing carousel');
      this.carousel.carousel();
      this.carousel.on('slide.bs.carousel', (e) => {
        this.currentSlide = e.to;
        console.log('carousel event');
      });
    },
    goto(slide) {
      this.carousel.carousel(slide);
    },
    next() {
      console.log('next', this.carousel);

      this.carousel.carousel('next');
    },
    prev() {
      this.carousel.carousel('prev');
    },
    productsInSlide(slide) {
      return this.products.slice(
        (slide - 1) * this.slideSize,
        slide * this.slideSize,
      );
    },
    productRedirection(productUrl) {
      if (productUrl.site_url) {
        this.openInNewTab(productUrl.site_url);
      }
    },
    isLink(item) {
      return item.max_timestamp !== undefined;
    },
    itemsCount(productItem) {
      if (this.isLink(productItem)) {
        return productItem.view_count;
      }
      if (productItem.count) {
        return productItem.count;
      }
      return 0;
    },
  },
};
</script>
<style>
.marker {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #646464;
}
</style>
<style lang="scss"
  scoped>
.indicators {
  list-style: none;
  display: flex;
  position: absolute;
  left: 50%;
  bottom: 3px;
  margin: 0;
  padding: 0;
  transform: translateX(-50%) translateY(100%);

  li {
    padding: 0 9px;
    cursor: pointer;
    opacity: 0.3;
    transition: all 0.2s;
    color: #646464;

    &.active {
      opacity: 1;
    }
  }
}

.carousel-control-prev,
.carousel-control-next {
  color: $black;
  width: 50px;
  opacity: 1;

  // &:hover {
  //   // color: $gray-light;
  // }
}

.carousel-control-prev {
  justify-content: start;
}

.carousel-control-next {
  justify-content: flex-end;
}
</style>
